import {
  GlobalActions,
  GlobalCommonInsuranceDataReceivedAction,
  GlobalFremdvermittlerChangedAction,
  GlobalVermittlerBnrBChangedAction,
  GlobalVermittlernummerChangeddAction,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { IAppState } from '../appState';

export const vermittlerReducer = function (
  sectionState: IAppState['vermittler'] = null,
  action: AnyAction,
): IAppState['vermittler'] {
  switch (action.type) {
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED:
      return setVermittlerNummer(sectionState, action as GlobalCommonInsuranceDataReceivedAction);
    case GlobalActions.VERMITTLER_NUMMER_CHANGED:
      return setVermittlerNummer(sectionState, action as GlobalVermittlernummerChangeddAction);
    case GlobalActions.VERMITTLER_FREMD_CHANGED:
      return setFremdvermittler(sectionState, action as GlobalFremdvermittlerChangedAction);
    case GlobalActions.VERMITTLER_BNRB_CHANGED:
      return setBnrB(sectionState, action as GlobalVermittlerBnrBChangedAction);
    default:
      return sectionState;
  }
};

function setVermittlerNummer(
  sectionState: IAppState['vermittler'],
  action: GlobalCommonInsuranceDataReceivedAction | GlobalVermittlernummerChangeddAction,
): IAppState['vermittler'] {
  const vermittler = action.payload.vermittlernummer;
  const stateKey = sectionState.isFremdvermittler ? 'fremd' : 'eigen';
  return {
    ...sectionState,
    selectedVermittlernummer: {
      ...sectionState.selectedVermittlernummer,
      [stateKey]: {
        vertreternummer: vermittler?.vertreternummer,
        geschaeftsstelle: vermittler?.geschaeftsstelle,
        zweigniederlassung: vermittler?.zweigniederlassung,
      },
    },
  };
}

function setFremdvermittler(
  sectionState: IAppState['vermittler'],
  action: GlobalFremdvermittlerChangedAction,
): IAppState['vermittler'] {
  return {
    ...sectionState,
    isFremdvermittler: action.payload.fremd,
  };
}

function setBnrB(
  sectionState: IAppState['vermittler'],
  action: GlobalVermittlerBnrBChangedAction,
): IAppState['vermittler'] {
  return {
    ...sectionState,
    bnrb: action.payload.bnrb,
  };
}
